import { render } from "./PsCheckboxValue.vue?vue&type=template&id=3b14e22b&ts=true"
import script from "./PsCheckboxValue.vue?vue&type=script&lang=ts"
export * from "./PsCheckboxValue.vue?vue&type=script&lang=ts"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__